<div class="row">
  <div class="col-12">
    <h5 class="flex-align-items space-between">
      <div>
        {{ (visibility == 'advanced' ? 'AdvancedMode' : 'ExpertMode') | translate }}
        <app-help hrefKey="ExternalHelp.expert" />
      </div>
      <div>
        <button
          id="modify"
          type="button"
          (click)="toggleEditMode()"
          class="btn btn-primary btn-sm pull-right"
          [hidden]="editMode"
          [innerHTML]="'Modifier' | translate"
        ></button>
        <button
          id="save"
          type="button"
          (click)="toggleEditMode()"
          [hidden]="!editMode"
          class="btn btn-sm btn-primary btn-sm pull-right"
          [innerHTML]="'Enregistrer' | translate"
        ></button>
        <button
          id="cancel"
          type="button"
          (click)="cancelUpdate()"
          [hidden]="!editMode"
          class="btn btn-danger btn-sm pull-right mr-2"
          [innerHTML]="'Annuler' | translate"
        ></button>
      </div>
    </h5>
    <p class="mb-0">
      {{ 'BrainTunablesDescription.' + visibility | translate }}
    </p>
    <div *ngIf="available(visibility) && showWarning" class="bg-orange" [innerHTML]="'ExpertWarning' | translate"></div>
    <hr style="margin-top: 0.8rem; margin-bottom: 0.8rem" />
    <div *ngIf="!available(visibility)" class="bg-blue">
      {{ 'SubscribeTo.' + visibility | translate }}
    </div>
    <app-brain-parameters
      [(hasError)]="hasError"
      [brainOverrides]="overrides"
      [editMode]="editMode"
      [paramGroups]="paramsGroups"
      [showUids]="true"
      [showVisibility]="showVisibility"
      [disabled]="!available(visibility)"
    ></app-brain-parameters>
    @if (!paramsGroups.length) {
      <ogo-spinner [inline]="true"></ogo-spinner>
    }
  </div>
</div>
